$(document).ready(function() {

	let place_selected = 'true';

	// search box
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}

	// open/close faqs
	if ($('.riv-faq').length > 0) {
		$('.riv-faq-question').on('click', function() {
			$(this).parent().toggleClass('riv-faq-active');
		});
	}

	// testimonials slider
	if ($('.riv-testimonial').length > 3) {
		var slider = $('.riv-testimonials-group').flickity({
			adaptiveHeight: false,
			cellAlign: 'center',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
		$('.riv-testimonial-button-prev').on('click', function(e) {
			e.preventDefault();
			slider.flickity('previous', true, false);
			var data = slider.data('flickity');
			$('.one-carousel-controls-pager a', group).removeClass('active');
			$('.one-carousel-controls-pager a[data-slide-index="' + data.selectedIndex + '"]', group).addClass('active');
		});
		$('.riv-testimonial-button-next').on('click', function(e) {
			e.preventDefault();
			slider.flickity('next', true, false);
			var data = slider.data('flickity');
			$('.one-carousel-controls-pager a', group).removeClass('active');
			$('.one-carousel-controls-pager a[data-slide-index="' + data.selectedIndex + '"]', group).addClass('active');
		});
	}

});
